import Env from '../base/env';
import Component from 'gia/Component';
import gsap from 'gsap';
import easesCustom from '../fx/CustomEases';
import { ScrollTrigger } from '../vendor/gsap-bonus-umd/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default class Module extends Component
{
  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    this.DOM.fxA = this.DOM.view.querySelector('.fxBgA')
    this.DOM.fxB = this.DOM.view.querySelector('.fxBgB')
    //! Fns
    setTimeout(() => {
      this._fx()
    }, Env.timingDelayFx);
  }

  _fx()
  {
    this.animate()
    this.reveal()
  }

  animate()
  {
    this.animation = gsap.timeline()

    this.animation
    .add([
      gsap.fromTo(
        this.DOM.fxA,
        {
          y:0
        },
        {
          y:'100%',
          ease:easesCustom.quart,
          duration:1.1
        }
      ),
      gsap.fromTo(
        this.DOM.fxB,
        {
          y:0
        },
        {
          y:'-100%',
          ease:easesCustom.quart,
          duration:1.1
        }
      ),
    ])

  }

  reveal()
  {
    this.st = ScrollTrigger.create({
      animation:this.animation,
      trigger:this.DOM.view,
      start:'top 50%',
    })
  }

  unmount()
  {
    this.st.kill(true)
  }
}
